import { AppCheckbox, AppCheckboxGroup, AppFormItem, AppText } from 'components/atoms';
import { PriceDisplay } from 'components/molecules';
import { childrenTexts } from 'consts/text';
import { MealPrice } from 'types';

type ChildrenMealSelectionProps = {
    meals: MealPrice[];
};

export const ChildrenMealSelection = ({ meals }: ChildrenMealSelectionProps) => (
    <>
        <AppText textType="BodyMSSemiBold" margin={0} marginBottom={12}>
            {childrenTexts.childDetails.additionalInfo.dietMeals.title}
        </AppText>
        <AppFormItem name="selectMealsType" marginBottom={12}>
            <AppCheckboxGroup>
                {meals?.map((meal) => (
                    <AppCheckbox
                        key={meal.mealTypeId}
                        value={meal.mealTypeId}
                        disabled={!meal.price}
                    >
                        {meal.name}{' '}
                        {meal.dateFrom && new Date(meal.dateFrom) > new Date()
                            ? `(od ${meal.dateFrom})`
                            : ''}
                        <PriceDisplay value={meal.price} />{' '}
                    </AppCheckbox>
                ))}
            </AppCheckboxGroup>
        </AppFormItem>
    </>
);
